import { render, staticRenderFns } from "./stanking-book.vue?vue&type=template&id=de249ba6&scoped=true&"
import script from "./stanking-book.vue?vue&type=script&lang=js&"
export * from "./stanking-book.vue?vue&type=script&lang=js&"
import style0 from "./stanking-book.vue?vue&type=style&index=0&id=de249ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de249ba6",
  null
  
)

export default component.exports